export default __webpack_public_path__ + "static/media/25.cd40fea1.svg";